import { Box, Text } from '@user-portal/wikr-components';
import React, { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { selectCancellationCandidate } from 'store/subscriptions/selectors';
import { selectCurrentUser } from 'store/user/selectors';

import { useSelector } from 'hooks';
import { useModals } from 'hooks/modals';

import Modal from 'components/Modal/Modal';
import OutlinedButton from 'components/OutlinedButton';
import SolidPaymentForm from 'components/SolidPaymentForm';

import normalizeDateByLocale from '../../SubscriptionsTab/components/SubscriptionCard/helpers/normalizeDateByLocale';

const BoldText = ({ content }: { content: string }) => (
    <Text inline medium type="large-text" bold>
        {content}
    </Text>
);

const CancellationFeePaymentModalContainer = () => {
    const { closeModal } = useModals();
    const { t } = useTranslation();

    const cancellationCandidate = useSelector(selectCancellationCandidate);
    const country = useSelector(selectCurrentUser).country;

    const expirationDate = normalizeDateByLocale(cancellationCandidate!.expired_date, country);

    const feeData = useMemo(() => {
        const {
            fee,
            product: { currency },
        } = cancellationCandidate!;

        return {
            amount: fee?.fee_price ? `${fee.fee_price} ${currency}` : '',
        };
    }, [cancellationCandidate]);

    return (
        <Modal isOpen withCloseButton onClose={closeModal} transparentBackground={false}>
            <Box $paddingTop={60} $paddingBottom={20} $paddingX={16}>
                <Text center mb={10} type="large-text">
                    {t('subscription.cancelFlow.commitment.payAndCancelText')}
                </Text>
                <Text center mb={24}>
                    <Trans
                        i18nKey="subscription.cancelFlow.commitment.payFeeModal.subtitle.new"
                        components={{
                            1: <BoldText key="1" content={feeData.amount} />,
                            2: <BoldText key="2" content={expirationDate} />,
                        }}
                    />
                </Text>
                <SolidPaymentForm />
                <OutlinedButton onClick={closeModal}>{t('subscription.cancelDialog.discard')}</OutlinedButton>
            </Box>
        </Modal>
    );
};

export default CancellationFeePaymentModalContainer;
